import { createSlice } from "@reduxjs/toolkit"
import { TAB_TRANSFER } from "../constants/constant"

const initialState = {
  selectedTabs: TAB_TRANSFER,
  currencies: [],
  payIns: [],
  selectedSourceCurrency: {
    value: "IDR",
    label: "IDR",
    note: "Indonesia Rupiah",
    currency: "IDR",
    searchable: "IDR, Indonesia, Rupiah",
  },
  selectedTargetCurrency: {
    value: "SGD",
    label: "SGD",
    note: "Singapore Dollar",
    currency: "SGD",
    searchable: "SGD, Singapore Dollar",
  },
  selectedPaymentMethod: {
    value: "BANK_TRANSFER",
    label: "Bank Transfer",
    note: "",
  },
  selectPaymentMethod: [],
  lockTarget: true,
  formValue: {
    transfer: {
      sourceCurrency: "IDR",
      targetCurrency: "SGD",
      sourceAmount: 150000,
      targetAmount: 0,
      preferredPayIn: "BANK_TRANSFER",
      guaranteedTargetAmount: true,
      rate: 0,
      transactionFee: 0,
      feePercentage: 0,
      totalAmount: 0,
      payInFee: 0,
      casferFixedFee: 0,
      partnerFee: 0,
      disabled: false,
      disabledReason: "",
    },
    trackTransfer: {},
  },
}

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setCurrencies: (state, action) => {
      state.currencies = action.payload
    },
    setPayIns: (state, action) => {
      state.payIns = action.payload
    },
    setSelectedTab: (state, action) => {
      state.selectedTabs = action.payload
    },
    setSelectedPaymentMethod: (state, action) => {
      state.selectedPaymentMethod = action.payload
    },
    setSelectPaymentMethod: (state, action) => {
      const optionName = [{ header: "Payment Methods" }]
      state.selectPaymentMethod = optionName.concat(action.payload)
    },
    setLockTarget: (state, action) => {
      state.lockTarget = action.payload
    },
    setSelectedSourceCurrency: (state, action) => {
      const { value, label, note, currency, searchable } = action.payload

      state.selectedSourceCurrency.value = value
      state.selectedSourceCurrency.label = label
      state.selectedSourceCurrency.note = note
      state.selectedSourceCurrency.currency = currency
      state.selectedSourceCurrency.searchable = searchable
    },
    setSelectedTargetCurrency: (state, action) => {
      const { value, label, note, currency, searchable } = action.payload

      state.selectedTargetCurrency.value = value
      state.selectedTargetCurrency.label = label
      state.selectedTargetCurrency.note = note
      state.selectedTargetCurrency.currency = currency
      state.selectedTargetCurrency.searchable = searchable
    },
    updateTransfer: (state, action) => {
      const {
        sourceCurrency,
        targetCurrency,
        sourceAmount,
        targetAmount,
        preferredPayIn,
        guaranteedTargetAmount,
        rate,
        transactionFee,
        feePercentage,
        totalAmount,
        payInFee,
        casferFixedFee,
        partnerFee,
        disabled,
        disabledReason,
      } = action.payload

      state.formValue.transfer.sourceCurrency = sourceCurrency
      state.formValue.transfer.targetCurrency = targetCurrency
      state.formValue.transfer.sourceAmount = sourceAmount
      state.formValue.transfer.targetAmount = targetAmount
      state.formValue.transfer.preferredPayIn = preferredPayIn
      state.formValue.transfer.guaranteedTargetAmount = guaranteedTargetAmount
      state.formValue.transfer.rate = rate
      state.formValue.transfer.transactionFee = transactionFee
      state.formValue.transfer.feePercentage = feePercentage
      state.formValue.transfer.totalAmount = totalAmount
      state.formValue.transfer.payInFee = payInFee
      state.formValue.transfer.casferFixedFee = casferFixedFee
      state.formValue.transfer.partnerFee = partnerFee
      state.formValue.transfer.disabled = disabled
      state.formValue.transfer.disabledReason = disabledReason
    },
  },
})

export const {
  setCurrencies,
  setSelectedTab,
  setSelectedSourceCurrency,
  setSelectedTargetCurrency,
  setSelectPaymentMethod,
  setSelectedPaymentMethod,
  updateTransfer,
  setPayIns,
  setLockTarget,
  setPaymentMethodOption,
} = homeSlice.actions
export default homeSlice.reducer
